/* eslint-disable */
import { useState } from 'react';
import { exportElementToPDF } from '../utils/exportPDF';

function BtnExportPDF({ targetRef, filename, label = '📄 Export PDF' }) {
  const [loading, setLoading] = useState(false);

  function handleExport() {
    exportElementToPDF(
      targetRef,
      filename,
      () => setLoading(true),
      () => setLoading(false)
    );
  }

  return (
    <button
      onClick={handleExport}
      disabled={loading}
      style={{
        padding: '9px 16px',
        background: loading ? '#aaa' : 'linear-gradient(135deg,#c0392b,#e74c3c)',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '13px',
        fontWeight: '600',
        cursor: loading ? 'not-allowed' : 'pointer',
        whiteSpace: 'nowrap',
      }}
    >
      {loading ? '⏳ Membuat PDF...' : label}
    </button>
  );
}

export default BtnExportPDF;